import { Routes } from "@angular/router";
import { AuthGuard, PlayerGuard, ContentGuard } from "src/app/services";
import { MarketplaceAdminGuard } from "../admin.guard";

export const marketplaceAdminRoutes: Routes = [
    {
        path: 'products',
        loadComponent: () => import('./products/products.component').then(c => c.ProductsComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard, MarketplaceAdminGuard],
    },
    {
        path: 'customers',
        loadComponent: () => import('./customers/customers.component').then(c => c.CustomersComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard, MarketplaceAdminGuard],
    },
    {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(c => c.MarketplaceAdminDashboardComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard, MarketplaceAdminGuard],
    },
    {
        path: 'orders',
        loadComponent: () => import('./orders/orders.component').then(c => c.OrdersComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard, MarketplaceAdminGuard],
    },
    {
        path: 'reports',
        loadComponent: () => import('./reports/reports.component').then(c => c.ReportsComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard, MarketplaceAdminGuard],
    },
    {
        path: 'products/edit/:id',
        loadComponent: () => import('./products/product-form/product-form.component').then(c => c.ProductFormComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard, MarketplaceAdminGuard],
    },
    {
        path: 'products/edit',
        redirectTo: 'products',
        pathMatch: 'full',
    },
    {
        path: 'products/create',
        loadComponent: () => import('./products/product-form/product-form.component').then(c => c.ProductFormComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard, MarketplaceAdminGuard],
    },
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    }
]
